import React from 'react';
import { Button } from './ui/button';
import { LayoutGrid, List, CalendarDays } from 'lucide-react';

/**
 * Reusable Card/List/Calendar view toggle component
 * Uses CharterShare brand blue (#2563EB) for active state
 */
const CardListViewToggle = ({ viewMode, onViewModeChange, showCalendar = false }) => {
  const activeStyle = { background: '#2563EB', color: 'white' };
  
  return (
    <div className="flex gap-1 items-center">
      {showCalendar && (
        <Button
          variant={viewMode === "calendar" ? "default" : "outline"}
          size="sm"
          onClick={() => onViewModeChange("calendar")}
          style={viewMode === "calendar" ? activeStyle : {}}
          className="h-9 w-9 p-0 flex items-center justify-center"
        >
          <CalendarDays className="w-4 h-4" />
        </Button>
      )}
      <Button
        variant={viewMode === "card" ? "default" : "outline"}
        size="sm"
        onClick={() => onViewModeChange("card")}
        style={viewMode === "card" ? activeStyle : {}}
        className="h-9 w-9 p-0 flex items-center justify-center"
      >
        <LayoutGrid className="w-4 h-4" />
      </Button>
      <Button
        variant={viewMode === "list" ? "default" : "outline"}
        size="sm"
        onClick={() => onViewModeChange("list")}
        style={viewMode === "list" ? activeStyle : {}}
        className="h-9 w-9 p-0 flex items-center justify-center"
      >
        <List className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default CardListViewToggle;
